var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link"},[_c('el-link',{attrs:{"type":"primary"},on:{"click":_vm.reOnClick}},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-fanhui-"}})]),_c('span',[_vm._v("返回")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }